export type SearchFilter = {
  columnName: string
  operation: string
  columnValue?: unknown
  subFilter?: SearchFilter[]
}

const NEGATIVE_OPERATIONS = ['NOT_MATCH_TO', 'NOT_EQUAL']

export const isNullFilter = (columnValue: unknown) => {
  const nullKeywords = ['IS_NULL', 'IS_NOT_NULL']
  return nullKeywords.includes(columnValue as string)
}

/**
 * Widens "Does Not Contain" / "Does Not Equal" to `(column IS NULL) OR (rule)`: the backend emits a bare `NOT LIKE`, which is
 * NULL rather than true for a null column, so accounts with no tags vanish. Delete once the backend tolerates null itself.
 */
export const includeNullsInNegativeFilters = (searchFilters?: SearchFilter[]) => {
  if (!Array.isArray(searchFilters)) {
    return searchFilters
  }

  return searchFilters.map(filter => {
    if (!NEGATIVE_OPERATIONS.includes(filter.operation)) {
      return filter
    }

    const { columnName, operation, columnValue } = filter
    return {
      columnName,
      // "OR", not "OR_WITH" — SearchOperationType names the constant OR_WITH but its wire value is "OR",
      // and an unknown operation throws rather than degrading.
      operation: 'OR',
      subFilter: [
        { columnName, operation: 'IS_NULL' },
        { columnName, operation, columnValue },
      ],
    }
  })
}
